import React from 'react';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import SimpleAvatar from '../../../../common/SimpleAvatar';
import Popup from '../../../../common/Popup';
import Icon from '../../../../Icon';
import { getSafeChannelName, getSafeRole } from '../../utils';
import { ACTIVITY_LOG_ROLE } from '../../../constants';
import { enhance } from './enhance';
import styles from './index.styl';

const { PATIENT } = ACTIVITY_LOG_ROLE;

function ChatMembersModal({
  intl: { formatMessage },
  openedChatMembersModal,
  mainUserId,
  channelName,
  memberList,
  date,
  close,
}) {
  const safeChatName = getSafeChannelName(channelName, formatMessage);

  return (
    <Popup
      title={formatMessage({
        id: 'patient.portal.healthRecord.activityLog.chatMembers',
      })}
      onClose={close}
      opened={openedChatMembersModal}
      mobileFullScreen={false}
      overflowVisible
      withoutAdaptive
      strictClose
    >
      <div className={styles.root}>
        <div className={styles.header}>
          <div className={styles.leftSideWrapper}>
            <Icon size={32} name="icon-group" className={styles.avatar} />
            <div className={styles.title}>{safeChatName}</div>
          </div>
          <div className={styles.date}>{date}</div>
        </div>
        <div className={styles.contentWrapper}>
          {memberList.map(
            ({ userId, lastName, firstName, role, avatar, id }) => {
              const mainUserName = userId === mainUserId;
              const isRolePatient = role === PATIENT;
              const safeMemberName = `${firstName || ''} ${lastName || ''}`;
              return (
                <div className={styles.memberCard} key={id}>
                  <div className={styles.leftSideWrapper}>
                    <SimpleAvatar
                      className={styles.avatar}
                      text={safeMemberName}
                      src={get(avatar, 'thumbMin')}
                      size={32}
                    />
                    <div className={styles.description}>
                      <div className={styles.title}>
                        {mainUserName
                          ? `${safeMemberName} (${formatMessage({
                              id: 'patient.portal.healthRecord.activityLog.you',
                            })})`
                          : safeMemberName}
                      </div>
                      <div className={styles.role}>
                        {mainUserName && isRolePatient
                          ? formatMessage({
                              id:
                                'patient.portal.healthRecord.activityLog.patient',
                            })
                          : getSafeRole(role, formatMessage)}
                      </div>
                    </div>
                  </div>
                </div>
              );
            },
          )}
        </div>
      </div>
    </Popup>
  );
}

ChatMembersModal.propTypes = {
  intl: PropTypes.object,
  close: PropTypes.func,
  channelName: PropTypes.string,
  memberList: PropTypes.array,
  date: PropTypes.string,
  mainUserId: PropTypes.number,
  openedChatMembersModal: PropTypes.bool,
};

export default enhance(ChatMembersModal);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/ChatMembersModal/index.jsx